import React, { useState, useEffect } from "react";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { CDBCard, CDBDataTable, CDBContainer, CDBCardBody } from 'cdbreact';
import '../user/AllUser.css';
// import { getAllCity, cityDeletion } from "./agepolicyAction";
import { getAllProductCommission, productcommissionDeletion } from "./commissionAction";
import { useDispatch, useSelector } from "react-redux";
import store from "../../../store";
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import Swal from "sweetalert2";
import { FaEdit, FaTrash, FaPlus, FaEye,FaArrowLeft } from 'react-icons/fa';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button1 from '@mui/material/Button';

const MasterPage = () => {
    const { productcomission, isLoading, dmessage } = useSelector((state) => state.productcommissionList);
    console.log("beeg",productcomission)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllProductCommission());
    }, [dmessage]);

    if (isLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {isLoading && <Spinner variant='info' center="true" animation='border' />}
                    {/*  <CountryList /> */}
                </Container>
            </>
        );
    }

    if (productcomission.length === 0) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl">
                    <div style={{ display: 'block', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createExcursionCommission/Holiday"><FaPlus className='fwcolor' /> Add Commission Details</Link>{' '}</div>
                </Container>
                <Container className="my-4 mx-4 container-xl">

                    <h2>No Product Commission to display.....</h2>
                    
                   
                </Container>
                
            </>
        );
    }

  
    return (
        <Container>

            <div className="users">
                <ProductCommissionList skey={productcomission.result3}  skey2={productcomission.result1} skey3={productcomission.result4} />
            </div>
        </Container>
    );
}

const ProductCommissionList = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [productcomissionid, setProductCommissionid] = useState('');

    useEffect(() => {
      dispatch(getSRolePermission());
      
  }, []);
  const onPagepath = () => {
    navigate('/createExcursionCommission/Holiday');
  } 

  const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
      (state) => state.rolePermissionList
    );

    const filteredPermissions = combinedrolepermissiondetails.filter(
      (item) => item.label === "Holiday"
    );
    
    let menu_add = 0;
    let menu_edit = 0;
    let menu_delete = 0;
    
    if (filteredPermissions.length > 0) {
      const permission = filteredPermissions[0];
      menu_add = permission.menu_add;
      menu_edit = permission.menu_edit;
      menu_delete = permission.menu_delete;
    }

    // const onProductCommissionDelete = (e, id) => {
    //     e.preventDefault();
    //      setProductCommissionid(id);
    //     //console.log('delete :'+ id);

    //     dispatch(productcommissionDeletion(id));
    //     dispatch(getAllProductCommission());
    //     navigate('/holidayCommissionList/Holiday');
    //     getAllProductCommission(); 
    //     //  window.location.reload(true);

    // }
    const onProductCommissionDelete = (e, id) => {  
      Swal.fire({
          title: 'Are you sure want to delete the Commission?',
          showDenyButton: true,
          icon:'error',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          denyButtonText: 'No',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 right-gap',
            confirmButton: 'order-2',
            denyButton: 'order-3',
          }
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(productcommissionDeletion(id)).then(() => {
              dispatch(getAllProductCommission());
             navigate('/holidayCommissionList/Holiday');
              Swal.fire('Commission Deleted Successfully!', '', 'success');
            })
        }
          else if (result.isDenied) {
            Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
          }
        })


  }

    const onProductCommissionView = (e, id) => {
      e.preventDefault();
     //console.log('select role '+id);
     navigate('/CommissionView/' + id+ "/holidayCommissionList/Holiday" ); 
 }



    const onProductCommissionModify = (e, id) => {
         e.preventDefault();
        //console.log('select role '+id);
        navigate('/ModifyCommission/' + id + "/holidayCommissionList/Holiday"); 
    }
    function rowClickEvent(param) {
        alert('Row Click Event');
    }

    // const data = () => {
    //     {console.log("buyyer",props.skey2)}
        
    //     const rData = props.skey.filter(obj => obj.service_type_id == "Excursion").map((user) => {
    //         console.log("sakyama",user)
    //         const productcomissionData = JSON.parse(JSON.stringify(user));
    //         // console.log('hell '+usersData.id);
    //         const rowData = {
    //              id: productcomissionData.id,
    //             name: productcomissionData.product_name,
    //             status: productcomissionData.status == 'Approved' ? <span className="badge bg-success"> Approved</span> : <span className="badge bg-danger"> Pending</span>,
    //             action: <> <Button className="btn btn-sm btn-warning" onClick={(e) => onProductCommissionModify(e, productcomissionData.product_id)} ><FaEdit className='fwcolor' /></Button> <Button className="btn btn-sm btn-danger" onClick={(e) => onProductCommissionDelete(e, productcomissionData.id)}><FaTrash className='fwcolor' /></Button></>,
    //          }
    //         // console.log('rowData '+rowData.action);
    //         return rowData;
    //     });

    //     //   console.log(rData);

    //     return {
    //         columns: [
    //             {
    //                 label: '#ID',
    //                 field: 'id',
    //                 width: 40,
    //                 sort: 'asc',
    //                 attributes: {
    //                     'aria-controls': 'DataTable',
    //                     'aria-label': 'ID',
    //                 },
    //             },
    //             {
    //                 label: 'Product Name',
    //                 field: 'name',
    //                 width: 200,
    //             },
    //             {
    //                 label: 'Status',
    //                 field: 'status',
    //                 width: 100,
    //             },
    //             {
    //                 label: 'Action',
    //                 field: 'action',
    //                 width: 200,
    //                 sort: 'disabled',
    //             },
    //         ],
    //         rows: rData,

    //     };
    // };
    // const data = () => {
    //     console.log("buyyer", props.skey2);
      
    //     const rejectedCounts = {};
      
    //     props.skey2.forEach((item) => {
    //       const { product_id, subproduct_id, status } = item;
      
    //       if (!rejectedCounts.hasOwnProperty(product_id)) {
    //         rejectedCounts[product_id] = {};
    //       }
      
    //       if (status === "Rejected") {
    //         if (!rejectedCounts[product_id].hasOwnProperty(subproduct_id)) {
    //           rejectedCounts[product_id][subproduct_id] = 0;
    //         }
    //         rejectedCounts[product_id][subproduct_id]++;
    //       }
    //     });
      
    //     console.log("Rejected counts:", rejectedCounts);
      
    //     const rData = props.skey.map((user) => {
    //       const productcomissionData = JSON.parse(JSON.stringify(user));
    //       const { id, product_name, status } = productcomissionData;
      
    //       const subproducts = rejectedCounts[id] ? Object.keys(rejectedCounts[id]) : [];
    //       const rejectedCount = subproducts.reduce((acc, subproduct_id) => {
    //         return acc + rejectedCounts[id][subproduct_id];
    //       }, 0);
      
    //       const rowData = {
    //         id: id,
    //         name: product_name,
    //         status:
    //           status === "Approved" ? (
    //             <span className="badge bg-success">Approved</span>
    //           ) : (
    //             <span className="badge bg-danger">Pending</span>
    //           ),
    //         rejectedCount: <span className="badge bg-danger">{rejectedCount}</span>,
    //         action: (
    //           <>
    //             <Button className="btn btn-sm btn-warning" onClick={(e) => onProductCommissionModify(e, id)}>
    //               <FaEdit className="fwcolor" />
    //             </Button>{" "}
    //             <Button className="btn btn-sm btn-danger" onClick={(e) => onProductCommissionDelete(e, id)}>
    //               <FaTrash className="fwcolor" />
    //             </Button>
    //           </>
    //         ),
    //       };
      
    //       if (subproducts.length > 0) {
    //         subproducts.forEach((subproduct_id, index) => {
    //           rowData[`subproduct${index + 1}`] = (
    //             <span className="badge bg-danger">{rejectedCounts[id][subproduct_id]}</span>
    //           );
    //         });
    //       }
      
    //       return rowData;
    //     });
      
    //     return {
    //         columns: [
    //             {
    //                 label: '#ID',
    //                 field: 'id',
    //                 width: 40,
    //                 sort: 'asc',
    //                 attributes: {
    //                     'aria-controls': 'DataTable',
    //                     'aria-label': 'ID',
    //                 },
    //             },
    //             {
    //                 label: 'Product Name',
    //                 field: 'name',
    //                 width: 200,
    //             },
    //             {
    //                 label: 'Status',
    //                 field: 'status',
    //                 width: 100,
    //             },
    //             {
    //                 label: 'Rejected Count',
    //                 field: 'rejectedCount',
    //                 width: 100,
    //             },
    //             {
    //                 label: 'Action',
    //                 field: 'action',
    //                 width: 200,
    //                 sort: 'disabled',
    //             },
    //         ],
    //         rows: rData,

    //     };
    // };

    const data = () => {
    //    -----------------------reject count------------
        const rejectedCounts = {};
      
        props.skey2.forEach((item) => {
          const { product_id, subproduct_id, status } = item;
      
          if (!rejectedCounts.hasOwnProperty(product_id)) {
            rejectedCounts[product_id] = {};
          }
      
          if (!rejectedCounts[product_id].hasOwnProperty(subproduct_id)) {
            rejectedCounts[product_id][subproduct_id] = 0;
          }
      
          if (status === "Rejected") {
            rejectedCounts[product_id][subproduct_id]++;
          }
        });


        // -----------approval count---------------
        const approvedCounts = {};
      
        props.skey2.forEach((item) => {
          const { product_id, subproduct_id, status } = item;
      
          if (!approvedCounts.hasOwnProperty(product_id)) {
            approvedCounts[product_id] = {};
          }
      
          if (!approvedCounts[product_id].hasOwnProperty(subproduct_id)) {
            approvedCounts[product_id][subproduct_id] = 0;
          }
      
          if (status === "Approved") {
            approvedCounts[product_id][subproduct_id]++;
          }
        });




          // -----------pending count---------------
          const pendingCounts = {};
      
          props.skey2.forEach((item) => {
            const { product_id, subproduct_id, status } = item;
        
            if (!pendingCounts.hasOwnProperty(product_id)) {
                pendingCounts[product_id] = {};
            }
        
            if (!pendingCounts[product_id].hasOwnProperty(subproduct_id)) {
                pendingCounts[product_id][subproduct_id] = 0;
            }
        
            if (status === "Pending") {
                pendingCounts[product_id][subproduct_id]++;
            }
          });
      
      

      
        const rData = props.skey.filter(obj => obj.service_type_id == "Holiday").map((user,index) => {
          const productcomissionData = JSON.parse(JSON.stringify(user));
          const { id,product_id, product_name, status } = productcomissionData;
            
           const productID = product_id; // Product ID to detect
           let count = 0;
         
           // Get the subproducts for product_id 1001 in table A
           const subproductsA = props.skey3.filter((item) => item.product_id === productID);
         
           // Get the subproducts for product_id 1001 in table B
           const subproductsB = props.skey2.filter((item) => item.product_id === productID);
         
           // Check if any subproduct in table A does not have a corresponding entry in table B
           subproductsA.forEach((subproductA) => {
             const subproductExists = subproductsB.some((subproductB) => subproductB.subproduct_id === subproductA.id);
             if (!subproductExists) {
               count++;
             }
           });
         
           console.log(`Number of newly added subproducts without commission for product_id ${productID}: ${count}`);
    
          const rowData = {
            id: index + 1,
            name: product_name,
            newSubproductCount: count > 0 ? <span className="badge bg-secondary" >{count}</span> : <span className="badge" style={{backgroundColor:"black"}}>0</span>,
           
            action: (
              <>
                {menu_edit===1 &&(<Button className="btn btn-sm btn-warning" onClick={(e) => onProductCommissionModify(e, product_id)}>
                  <FaEdit className="fwcolor" />
                </Button>)}{" "}
                {menu_delete===1 && (<Button className="btn btn-sm btn-danger" onClick={(e) => onProductCommissionDelete(e, product_id)}>
                  <FaTrash className="fwcolor" />
                </Button>)}{" "}
                <Button className="btn btn-sm btn-primary" onClick={(e) => onProductCommissionView(e, product_id)}>
                  <FaEye className="fwcolor" />
                </Button>
              </>
            ),
          };
      
          const rejectedCount = Object.keys(rejectedCounts[product_id] || {}).reduce((acc, subproduct_id) => {
            return acc + rejectedCounts[product_id][subproduct_id];
          }, 0);
      
          if (rejectedCount > 0) {
            rowData.rejectedCount = <span className="badge bg-danger">{rejectedCount}</span>;
          }else{
            rowData.rejectedCount = <span className="badge bg-success">0</span>;
          }

        //   --------------appproval------
        const approvedCount = Object.keys(approvedCounts[product_id] || {}).reduce((acc, subproduct_id) => {
            return acc + approvedCounts[product_id][subproduct_id];
          }, 0);
      
          if (approvedCount > 0) {
            rowData.approvedCount = <span className="badge bg-success">{approvedCount}</span>;
          }else{
            rowData.approvedCount = <span className="badge bg-success">0</span>;
          }
      

                  //   --------------pending------
        const pendingCount = Object.keys(pendingCounts[product_id] || {}).reduce((acc, subproduct_id) => {
            return acc + pendingCounts[product_id][subproduct_id];
          }, 0);
      
          if (pendingCount > 0) {
            rowData.pendingCount = <span className="badge bg-primary">{pendingCount}</span>;
          }else{
            rowData.pendingCount = <span className="badge bg-primary">0</span>;
          }

          
      
      
          return rowData;
        });
       
        return {
          columns: [
            {
              label: '#ID',
              field: 'id',
              width: 40,
              sort: 'asc',
              attributes: {
                'aria-controls': 'DataTable',
                'aria-label': 'ID',
              },
            },
            {
              label: 'Product Name',
              field: 'name',
              width: 200,
            },
            {
                label: 'New Sub Product',
                field: 'newSubproductCount',
                width: 200,
              },
           
            {
              label: 'Pending',
              field: 'pendingCount',
              width: 100,
            },
            {
                label: 'Approved',
                field: 'approvedCount',
                width: 100,
              },
              {
                label: 'Rejected',
                field: 'rejectedCount',
                width: 100,
              },
            {
              label: 'Action',
              field: 'action',
              width: 200,
              sort: 'disabled',
            },
          ],
          rows: rData,
        };
      };
      
      

    return (
        <>
            <Container className="my-4  container-xl">

            <Card style={{marginTop:'-80px'}}>
                    <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Holiday Commission Details </h4>
                    {/* {menu_add===1 &&(<div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createExcursionCommission/Holiday"><FaPlus className='fwcolor' /> Add Commission Details</Link>{' '}</div>)}  */}
                    {menu_add===1 &&(<Button1 variant="contained" onClick={onPagepath} color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                          Add Commission Details
                        </Button1>)} 
                    
                    </Card.Header>
                    <Card.Body>
                    <Row>
                      <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 

                      </Row>
                      <br />
                        <CDBContainer>
                            <CDBCard>
                                <CDBCardBody>
                                {data()?.rows?.length  > 0 ? <>
                                    <CDBDataTable
                                        responsive
                                        striped
                                        bordered
                                        hover
                                        style={{width:'878px'}}
                                        noBottomColumns={true} 
                                        maxHeight="300px"
                                        data={data()}
                                        materialSearch
                                        fullPagination
                                    />
                    </> : <> <div style={{ width: "900px", textAlign: 'center' }}>No data available.</div>
                    </>}
                                </CDBCardBody>
                            </CDBCard>
                        </CDBContainer>
                    </Card.Body>
                </Card>
                

            </Container>
        </>
    );
};


export default MasterPage;